export default "__VITE_ASSET__o6KIE_la__"